module.exports = __webpack_public_path__ + "static/media/28-2.4a20313d.mp3";